import type { Directive } from 'vue';
import { uuid } from '../util'

let documentCallbacks = {};

export function getWindowScrollPos() {

    let doc = document.documentElement;
    let left = doc.scrollLeft;
    let top = doc.scrollTop;

    return { left, top };
}

export const clickOutsideDirective: Directive = {

    mounted: function(el: HTMLElement, binding) {

        const component = binding.instance;
        const $root = component.$root.$el;

        let touchDownPosition = null;

        // Document callback
        const documentCb = function(e) {

            if(!document.body.contains(e.target) || !$root.contains(e.target) || el.contains(e.target) || e.target == el){
                return;
            }

            if(touchDownPosition !== null){

                // Check touch offset
                const scroll = getWindowScrollPos();

                const xOffset = Math.abs(scroll.left - touchDownPosition.left);
                const yOffset = Math.abs(scroll.top - touchDownPosition.top);

                if(xOffset > 10 || yOffset > 10){
                    return;
                }
            }

            if(binding.value){
                binding.value(e);
            }

            touchDownPosition = null;

        }.bind(component);

        const onTouchStart = function() {
            touchDownPosition = getWindowScrollPos();
        };

        const uniqueId = uuid();
        el.dataset.clickOutsideElementId = uniqueId;

        documentCallbacks[uniqueId] = [documentCb, onTouchStart];
        document.addEventListener('click', documentCb);
        document.addEventListener('touchend', documentCb);
        document.addEventListener('touchstart', onTouchStart);
    },

    unmounted: function(el: HTMLElement) {

        const uniqueId = el.dataset.clickOutsideElementId;
        const callbacks = documentCallbacks[uniqueId];

        if(callbacks){

            document.removeEventListener('click', callbacks[0]);
            document.removeEventListener('touchend', callbacks[0]);
            document.removeEventListener('touchstart', callbacks[1]);
            delete documentCallbacks[uniqueId];
        }
    }
}